module.exports = __webpack_public_path__ + "img/icon04.528cfa2.png";